import React, { useState, useEffect, useRef, useContext } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Carousel } from "primereact/carousel";
import {
  Button,
  ConfirmDialog,
  Dialog,
  InputText,
  Checkbox,
  TabView,
  TabPanel,
} from "primereact";
import { FileUpload } from "primereact/fileupload";
import { InputNumber } from "primereact/inputnumber";
import { SplitButton } from "primereact/splitbutton";

// ------------------ COMPONENTES DE BASE--------------------------------
import { useForm } from "../../../../../Base/Hooks/useForm";
import AutoCompleteDropdown from "../../../../../Base/Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { downloadFile, uploadHandlerImg } from "../../../../../Base/Services/ArchivosService";
import Loader from "../../../../../Base/Components/Loader/Loader";
import Card from "../../../../../Base/Components/Card/Card";
import { ObtenerTipoProductosAct } from "../../../../../Base/API/Global/TipoProducto/TipoProductoRequest";
import { obtenerUnitsAct } from "../../../../../Base/API/Global/UnidadesMedida/UnitRequests";
import { obtenerSubCategoriasAct } from "../../../../../Base/API/Global/SubCategorias/SubCategoriasRequests";
import { obtenerCategoriasAct } from "../../../../../Base/API/Global/Categorias/CategoriasRequests";
import { ObtenerCurrency } from "../../../../../Base/API/Global/Currency/CurrencyRequest";
import {
  descargarImagenes,
  eliminarImagen,
  getListadoImagenes,
  mostrarImagenesProductos,
} from "../../../../../Base/API/IT/Imagenes/ImagenesRequest";
import { getPermisosGenerales } from "../../../../../Base/API/Global/PermisosGenerales/PermisosGeneralesRequest";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";

// ------------------- CONSULTAS A LA API--------------------------------
import { obtenerProductos, addProducto } from "../../../../../API/Global/Productos/ProductosRequests";
import { getBandejasActivas, getPosicionesAct } from "../../../../../API/Suministros/SuministrosRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { getBodegasAct, getEstantesAct } from "../../../../../API/Suministros/SuministrosRequest";

const CrudProductoModal = ({
  productos,
  setSelected,
  productosDialog,
  setProductosDialog,
  getProductos,
  modo,
  setEtiquetaQR,
  setShowEtiqueta,
  IdType,
}) => {

  const fileUpload = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);
  const [hiddenAgregarImg, setHiddenAgregarImg] = useState(userAuth.AccessWeb?.split(",").map((e) => parseInt(e)).includes(46),);
  const [obtenerProducto, setObtenerProducto] = useState([{}]);
  const [estados, setEstados] = useState([{}]);
  const [subCategoria, setSubCategoria] = useState([{}]);
  const [tipoProducto, setTipoProducto] = useState([{}]);
  const [posicion, setPosicion] = useState([{}]);
  const [unidadMedida, setUnidadMedida] = useState([{}]);
  const [unidadMedidaVU, setUnidadMedidaVU] = useState([{}]);
  const [categoria, setCategoria] = useState([{}]);
  const [bodega, setBodegas] = useState([{}]);
  const [estante, setEstante] = useState([{}]);
  const [moneda, setMoneda] = useState([{}]);
  const [permisosG, setPermisosG] = useState([]);
  const [listadoArchivos, setListadoArchivos] = useState([]);
  const [bandeja, setBandeja] = useState([]);
  const [imagenAgregada, setImagenAgregada] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imagenes, setImagenes] = useState([]);
  const [showModalImagenes, setShowModalImagenes] = useState(false);
  const [camposHabilitados, setCamposHabilitados] = useState(true);
  const [showDialogCodigo, setShowDialogCodigo] = useState(false);
  const [eliminarr, setEliminarr] = useState(false);
  const [img, setImagen] = useState([]);
  const [botonImg, setBotonImg] = useState(false);
  const esMateriaPrima = IdType === 34;

  const getFormattedDate = () => {
    const currentDate = new Date();
    const day = ("0" + currentDate.getDate()).slice(-2);
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const year = currentDate.getFullYear().toString().slice(-2); // Obtener solo los últimos dos dígitos del año
    let hours = currentDate.getHours();
    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convertir las horas al formato de 12 horas
    const minutes = ("0" + currentDate.getMinutes()).slice(-2);
    const seconds = ("0" + currentDate.getSeconds()).slice(-2);

    const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${meridiem}`;
    return formattedDate;
  };

  const initialValues = {
    IdProduct: -1,
    CodigoProducto: "",
    NombreProducto: "",
    DescripcionProducto: "",
    FechaUpdate: getFormattedDate(),
    CantidadMaxima: "",
    Minimo: "",
    IdUnit: "",
    UnitVidaUtil: "",
    VidaUtil: "",
    IdTipoProducto: "",
    IdSubCategoria: "",
    IdPosicion: "",
    IdStatus: "",
    FechaModificacion: getFormattedDate(),
    AutorizaBodega: productos ? productos?.AutorizaBodega : "",
    AutorizaGerente: productos ? productos?.AutorizaGerente : "",
    PermisoSalidaBodegaSolicita: productos
      ? productos?.PermisoSalidaBodegaSolicita
      : "",
    PermisoSalidaBodegaRecibe: productos
      ? productos?.PermisoSalidaBodegaRecibe
      : "",
    PermisoSalidaBodegaMASS: productos
      ? productos?.PermisoSalidaBodegaMASS
      : "",
    PermisoSalidaBodegaRRHH: productos
      ? productos?.PermisoSalidaBodegaRRHH
      : "",
    IdCurrency: "",
    IdBodega: "",
    IdEstante: "",
    IdBandeja: "",
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const obtProducto = await obtenerProductos();
    const estadosTempo = await getEstadosCategory("Productos");
    const subCategorias = await obtenerSubCategoriasAct();
    const unitMedida = await obtenerUnitsAct();
    const posicion1 = await getPosicionesAct();
    const tipoProducto = await ObtenerTipoProductosAct();
    const categoriaActiva = await obtenerCategoriasAct();
    const bodegaActiva = await getBodegasAct();
    const estanteActiva = await getEstantesAct();
    const monedasAct = await ObtenerCurrency();
    const permisos = await getPermisosGenerales();
    const a = await getListadoImagenes(productos?.CodigoProducto);
    const bandejaActiva = await getBandejasActivas();

    setListadoArchivos(a);
    setObtenerProducto(obtProducto);
    setEstados(estadosTempo);
    setSubCategoria(subCategorias);
    setUnidadMedida(unitMedida);
    setUnidadMedidaVU(unitMedida);
    setPosicion(posicion1);
    setTipoProducto(tipoProducto);

    setBodegas(bodegaActiva);
    setEstante(estanteActiva);
    setMoneda(monedasAct);
    setPermisosG(permisos);
    setBandeja(bandejaActiva);

    let categoriasFiltradas = categoriaActiva.filter((i) => Number(i?.IdType) === Number(IdType));
    setCategoria(categoriasFiltradas);

    const estadoInicial =
      modo === "Crear"
        ? estadosTempo[0]
        : estadosTempo.find((e) => e.IdStatus === productos?.IdStatus);

    setValues((prevValues) => ({
      ...productos,
      ...obtProducto,
      Estado: estadoInicial,
      FechaUpdate:
        modo === "Crear" ? getFormattedDate() : productos?.FechaUpdate,
      UnidadMedida: unitMedida.find((u) => productos?.IdUnit === u?.IdUnit),
      UnidadMedidaVU: unitMedida.find(
        (u) => Number(productos?.UnitVidaUtil) === Number(u?.IdUnit)
      ),
      TipoProducto: tipoProducto.find(
        (t) => productos?.IdTipoProducto === t.IdTipoProducto,
      ),
      SubCategoria: subCategorias.find(
        (s) => productos?.IdSubCategoria === s.IdSubCategoria,
      ),
      Posicion: posicion1.find((p) => productos?.IdPosicion === p.IdPosicion),
      Categoria: modo === "Crear" ? null : categoriasFiltradas.find(
            (c) => Number(productos?.IdCategoria) === Number(c.IdCategoria)
      ),
      Bandeja: bandejaActiva.find(
        (ba) => productos?.IdBandeja === ba?.IdBandeja,
      ),
      Estante: estanteActiva.find(
        (es) => productos?.IdEstante === es.IdEstante,
      ),
      Bodega: bodegaActiva.find((b) => productos?.IdBodega === b.IdBodega),
      Moneda: monedasAct.find((b) => productos?.IdCurrency === b.IdCurrency),
      AutorizaBodega: prevValues.AutorizaBodega || false,
      AutorizaGerente:
        modo === "Crear" ? true : prevValues.AutorizaGerente || false,
      PermisoSalidaBodegaSolicita:
        modo === "Crear"
          ? true
          : prevValues.PermisoSalidaBodegaSolicita || false,
      PermisoSalidaBodegaRecibe: prevValues.PermisoSalidaBodegaRecibe || false,
      PermisoSalidaBodegaMASS: prevValues.PermisoSalidaBodegaMASS || false,
      PermisoSalidaBodegaRRHH: prevValues.PermisoSalidaBodegaRRHH || false,
    }));
    setLoading(false);
  };

  const referencia = {
    IdRef: productos?.IdProduct,
    Codigo: productos?.CodigoProducto,
  };

  const subirArchivo = async (e) => {
    const archivosGuardados = await getArchivos();
    if (referencia.Codigo === undefined) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Guarde el producto antes de agregar imágenes.",
      );
    } else {
      if (archivosGuardados?.length + e.files.length > 3) {
        if (toast) {
          toastShow(toast, "error", "Solo se permiten subir hasta 3 archivos.");
        }
        return;
      }

      const inputs = [
        {
          name: "IdRef",
          type: "text",
          value: referencia.IdRef,
        },
        {
          name: "Codigo",
          type: "text",
          value: referencia.Codigo,
        },
      ];
      uploadHandlerImg({ e, inputs, toast, ref: fileUpload, getArchivos });
      setImagenAgregada(true);
      getArchivos();
    }
  };

  const getArchivos = async () => {
    const a = await getListadoImagenes(productos?.CodigoProducto);
    setListadoArchivos(a);
    return a;
  };

  const getArchivo = async (nombre) => {
    const a = await descargarImagenes(productos?.CodigoProducto, nombre);
    downloadFile(a, nombre);
  };

  const eliminar = async (nombre) => {
    await eliminarImagen(productos?.CodigoProducto, nombre);
    toastShow(toast, "success", "Eliminado", "Imagen eliminada correctamente.");
    setListadoArchivos(listadoArchivos.filter((archivo) => archivo !== nombre));
  };

  const eliminarImagenn = (a) => {
    setEliminarr(true);
    setImagen(a);
  };

  const onHideelimnar = () => {
    setEliminarr(false);
  };

  const onConfirmEliminacion = () => {
    setEliminarr(false);
    eliminar(img);
  };

  const verImagenes = async () => {
    if (imagenes.length === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Este productos no tiene imágenes.",
      );
    } else {
      getImagenes();
      setShowModalImagenes(true);
    }
  };

  const onHide = () => {
    setProductosDialog(false);
    resetForm();
    getProductos();
  };

  const verificarInfo = (e) => {
    let error = {};
    let showErrorToast = false;

    // Validación de campos requeridos Produto
    if (!values.NombreProducto) {
      error.NombreProducto = true;
      error.error = true;
      showErrorToast = true;
    }

    // Validar el campo de Descripción del Producto
    if (values.DescripcionProducto && !/^[A-Za-z0-9ÁÉÍÓÚáéíóúÑñ\s.\-_]*$/.test(values.DescripcionProducto)) {
      error.DescripcionProducto = true;
      error.error = true;
      showErrorToast = true;
    }

    // Validación de campos requeridos Estado
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdStatus = true;
      error.error = true;
      showErrorToast = true;
    }
    
    // Validación de campos requeridos Categoria 
    if (!values.Categoria || !values.Categoria.IdCategoria) {
      error.IdCategoria = true;
      error.error = true;
      showErrorToast = true;
    }
    // Validación de campos requeridos Subcategoria
      if (!values.SubCategoria || !values.SubCategoria.IdSubCategoria) {
      error.IdSubCategoria = true;
      error.error = true;
      showErrorToast = true;
    }

    // Validación de campos requeridos Tipo Producto
    // if (!values.TipoProducto || !values.TipoProducto.IdTipoProducto) {
    //   error.IdTipoProducto = true;
    //   error.error = true;
    //   showErrorToast = true;
    // }

    // Validación de campos requeridos Moneda
    if (!values.Moneda || !values.Moneda.IdCurrency) {
      error.IdCurrency = true;
      error.error = true;
      showErrorToast = true;
    }

    // Validación de campos requeridos Unidad de Medida
    if (!values.UnidadMedida || !values.UnidadMedida.IdUnit) {
      error.IdUnit = true;
      error.error = true;
      showErrorToast = true;
    }

    // if (values.Categoria?.IdCategoria !== 31) { // 

    //   if (camposHabilitados && !esMateriaPrima) {
    //     if (!values.CantidadMaxima) {
    //       error.CantidadMaxima = true;
    //       error.error = true;
    //       showErrorToast = true;
    //     }

    //     if (!values.Minimo) {
    //       error.Minimo = true;
    //       error.error = true;
    //       showErrorToast = true;
    //     }
    //   }
    // }

    setError(error);

    if (showErrorToast) {
      toastShow(
        toast,
        "warn",
        "Campo requerido",
        "Por favor, complete todos los campos requeridos.",
      );
    }

    return error;
  };

  // Funcion para Agregar Producto y Editar Producto dependiendo del modo en que se encuentre el modal
  const agregarProducto = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const existingProduct = obtenerProducto.find((pr) => pr.NombreProducto === values?.NombreProducto);

      if (existingProduct && (modo === "Crear" || existingProduct.IdProduct !== values.IdProduct)) {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un Producto con ese nombre",
        );
      } else {
        let PosicionAct = values.Posicion?.IdPosicion;
        if (values.Categoria.IdCategoria === 31) {
          PosicionAct = null;
        }
        let estadoId = null;
        if (values.Estado) {
          estadoId = values.Estado.IdStatus;
        }
        const a = {
          IdProduct: values?.IdProduct,
          NombreProducto: values.NombreProducto,
          DescripcionProducto: values.DescripcionProducto,
          FechaUpdate: values.FechaUpdate,

          CantidadMaxima: esMateriaPrima ? 0 : values.CantidadMaxima,
          Minimo: esMateriaPrima ? 0 : values.Minimo,
          IdUnit: values.UnidadMedida?.IdUnit,
          NoParte: values.NoParte || null,
          Medida: values?.Medida,


          IdTipoProducto: values.TipoProducto?.IdTipoProducto || null,
          IdSubCategoria: values.SubCategoria?.IdSubCategoria,
          IdPosicion: esMateriaPrima ? null : PosicionAct,

          IdStatus: estadoId,
          FechaModificacion: values.FechaModificacion,

          AutorizaBodega: esMateriaPrima ? false : values.AutorizaBodega,
          AutorizaGerente: esMateriaPrima ? true : values.AutorizaGerente,
          
          PermisoSalidaBodegaSolicita: esMateriaPrima
            ? true
            : values.PermisoSalidaBodegaSolicita,

          PermisoSalidaBodegaRecibe: esMateriaPrima
            ? false
            : values.PermisoSalidaBodegaRecibe,

          PermisoSalidaBodegaMASS: esMateriaPrima
            ? false
            : values.PermisoSalidaBodegaMASS,

          PermisoSalidaBodegaRRHH: esMateriaPrima
            ? false
            : values.PermisoSalidaBodegaRRHH,

          IdCurrency: values.Moneda?.IdCurrency,
          IdBodega: esMateriaPrima ? null : values.Bodega?.IdBodega,
          IdEstante: esMateriaPrima ? null : values.Estante?.IdEstante,
          IdBandeja: esMateriaPrima ? null : values.Bandeja?.IdBandeja,

          CodigoFinanzas: values?.CodigoFinanzas,
          IdType: IdType,

          UnitVidaUtil: esMateriaPrima ? null : values?.UnidadMedidaVU?.IdUnit,
          VidaUtil: esMateriaPrima ? null : values?.VidaUtil,

          IdUserUpdate: userAuth?.IdUser,
        };

        const respuesta = await addProducto(a);
        if (!respuesta || !Array.isArray(respuesta) || !respuesta[0]) {
          toastShow(
            toast,
            "error",
            "Error",
            "El servidor no devolvió una respuesta válida. Revisa la consola o el backend."
          );
          return;
        }

        if (respuesta[0].ESTADO === 1) {
          setLoading(true);
          toastShow(toast, "success", "Datos Agregados", respuesta[0].MENSAJE);
          getProductos();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
        }
      }
    }
  };

  const getImagenes = async () => {
    const i = await getListadoImagenes(productos?.CodigoProducto);
    if (i?.length > 0) {
      let n = await Promise.all(
        i.map(async (e) => {
          try {
            const a = await mostrarImagenesProductos(
              productos?.CodigoProducto,
              e,
            );
            return a;
          } catch (e) {
            return e;
          }
        }),
      );
      setImagenes({ CodigoProducto: productos?.CodigoProducto, img: n });
    } else {
      setImagenes([]);
    }
  };

  const footerContent = (
    <div>
      <Button
        label="Codigo QR"
        className="p-button-text"
        onClick={() => {
          window.open(
            `${process.env.REACT_APP_ENV}/EtiquetaProductoQR/print/${productos?.CodigoProducto}/1`,
            productos[0]?.CodigoProducto,
            "height=1200,width=1000",
            setShowDialogCodigo(false),
          );
        }}
      />
      <Button
        label="Codigo de Barras"
        className="p-button-text"
        onClick={() => {
          window.open(
            `${process.env.REACT_APP_ENV}/EtiquetaProducto/print/${productos?.CodigoProducto}/2`,
            productos[0]?.CodigoProducto,
            "height=1200,width=1000",
            setShowDialogCodigo(false),
          );
        }}
      />
    </div>
  );

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarProducto();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  const cerrarModal = () => {
    setShowModalImagenes(false);
  };

  useEffect(() => {
    if (productosDialog) {
      getValoresIniciales();
      getImagenes();
    }
  }, [productosDialog]);

  useEffect(() => {
    if (productos?.CodigoProducto) {
      getArchivos();
    }
  }, [productos?.CodigoProducto]);

  useEffect(() => {
    getArchivos();
  }, []);

  useEffect(() => {
    if (values.Categoria?.EsServicio || values.Categoria?.IdCategoria === 11) {
      setCamposHabilitados(false);
      setValues({
        ...values,
        UnidadMedida: unidadMedida.find(
          (u) => u.IdUnit === 6 && u.UnitName === "Unidad",
        ),
        Bodega: "",
        Estante: "",
        Bandeja: "",
        Posicion: "",
        IdBodega: null,
        IdEstante: null,
        IdPosicion: null,
        IdBandeja: null,
        Minimo: null,
        Maximo: null,
      });
    } else {
      setValues({
        ...values,
      });
      setCamposHabilitados(true);
    }
  }, [values.Categoria?.IdCategoria]);

  useEffect(() => {
    if (values.SubCategoria?.IdSubCategoria) {
      setValues({
        ...values,
      });
    }
  }, [values.SubCategoria?.IdSubCategoria]);

  const items = [
    {
      label: "Codigo QR",
      icon: "",
      command: () => {
        setShowEtiqueta(true);
        setEtiquetaQR(true);
      },
    },
    {
      label: "Código de Barras",
      icon: "",
      command: () => {
        setShowEtiqueta(true);
        setEtiquetaQR(false);
      },
    },
  ];

  useEffect(() => {
    setImagenAgregada(true);
  }, [listadoArchivos]);

  useEffect(() => {
    if (listadoArchivos?.length > 0) {
      getImagenes();
      setTimeout(() => {
        setBotonImg(true);
      }, 700);
    } else {
      setBotonImg(false);
    }
  }, [listadoArchivos]);

  const dialogTitle = !values.IdProduct
    ? "Nuevo Producto"
    : "Actualizar Producto ";

  const titleDialog = (
    <div className="d-flex align-items-center mt-2">
      <h2>{dialogTitle}</h2>
      <span>&nbsp;&nbsp;</span>
      <h1 className="fw-bold">{values.CodigoProducto}</h1>
      {values.CodigoProducto && (
        <SplitButton
          label=""
          className="p-button-text mx-2"
          icon="pi pi-print"
          tooltip="Imprimir Etiqueta"
          onClick={(e) => {
            setShowEtiqueta(true);
            setEtiquetaQR(true);
          }}
          model={items}
        />
      )}
    </div>
  );

  return (
    <div>
      {/* Dialogo para mostrar etiquetas */}
      <Dialog
        visible={productosDialog}
        modal
        header={titleDialog}
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
        style={{ width: "60%", maxHeight: "95vh" }}
        closeOnEscape={false}
      >
        <Toast ref={toast} />

        <ConfirmDialog
          visible={eliminarr}
          onHide={onHideelimnar}
          message="¿Está seguro de que desea eliminar la imágen del producto?"
          header="Eliminar"
          icon="pi pi-exclamation-triangle"
          acceptLabel="Sí"
          rejectLabel="No"
          accept={onConfirmEliminacion}
          reject={onHideelimnar}
        />

        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <TabView>
            <TabPanel header="Datos Generales">
              <div
                style={{ width: "100", margin: "auto" }}
                className="flex-wrap"
              >
                {/* Nombre del Producto */}
                <div className="modal__input-contenedor">
                  <div className={`field ${esMateriaPrima ? "col-6" : "col-4"} me-2`}>
                    <span className="p-float-label">
                      <InputText
                        name="NombreProducto"
                        value={values.NombreProducto}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.NombreProducto ? "p-invalid" : ""}
                      />
                      <label htmlFor="NombreProducto">Nombre Producto</label>
                    </span>
                  </div>
                   
                  {/* Numero de Parte */}
                  {!esMateriaPrima && (
                    <div className="field col-4 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="NoParte"
                          value={values.NoParte}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          className={error.NoParte ? "p-invalid" : ""}
                        />
                        <label htmlFor="NoParte">Numero de Parte</label>
                      </span>
                    </div>
                  )}

                  {/* Medida */}
                  {!esMateriaPrima && (
                    <div className="field col-4 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Medida"
                          value={values.Medida}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          className={error.Medida ? "p-invalid" : ""}
                        />
                        <label htmlFor="Medida">Medida</label>
                      </span>
                    </div>
                  )}

                </div>

                {/* Descripción del Producto */}
                <div className="modal__input-contenedor">
                  <div className={`field ${esMateriaPrima ? "col-12" : "col-8"} me-2`}>
                    <span className="p-float-label">
                      <InputText
                        name="DescripcionProducto"
                        value={values.DescripcionProducto}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        className={error.DescripcionProducto ? "p-invalid" : ""}
                      />
                      <label htmlFor="DescripcionProducto">
                        Descripción Producto
                      </label>
                      {error.DescripcionProducto && (
                        <small className="p-error">
                          La Descripción solo puede contener letras, números,
                          espacios y los caracteres '.', '_', '-'.
                        </small>
                      )}
                    </span>
                  </div>
                </div>

                {/* Estado , Categoria y SubCategoría */}
                <div className="modal__input-contenedor">
                  <div className="field col-3 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Estado"}
                        value={values.Estado}
                        items={estados}
                        field={"StatusName"}
                        label={"Estado"}
                        handleInputChange={handleInputChange}
                        className={error.IdStatus ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                  {/* Categoría */}
                  <div className="field col-3 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Categoria"}
                        value={values.Categoria}
                        items={categoria}
                        field={"NombreCategoria"}
                        label={"Categoría"}
                        handleInputChange={(e) => {
                          handleInputChange(e);
                          setValues((prevValues) => ({
                            ...prevValues,
                            SubCategoria: null,
                            TipoProducto: null,
                            IdTipoProducto: null,
                            IdSubCategoria: null,
                          }));
                        }}
                        //enable={true}
                        className={error.IdCategoria ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                  {/* SubCategoría */}
                  <div className="field col-3 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        enable={!!values.Categoria}
                        name={"SubCategoria"}
                        value={values.SubCategoria}
                        items={subCategoria}
                        field={"NombreSubcategoria"}
                        label={"SubCategoría"}
                        handleInputChange={(e) => {
                          handleInputChange(e);
                          if (
                            values?.SubCategoria?.IdSubCategoria !==
                            e?.IdSubCategoria
                          ) {
                            setValues((prevValues) => ({
                              ...prevValues,
                              IdTipoProducto: null,
                              TipoProducto: null,
                            }));
                          }
                        }}
                        className={error.IdSubCategoria ? "p-invalid" : ""}
                        filterValue={values?.Categoria}
                        itemsFilter={(e) => {
                          let filtro = subCategoria.filter(
                            (s) =>
                              s.IdCategoria === values?.Categoria?.IdCategoria,
                          );
                          let filtro2 = values?.Categoria?.IdCategoria;
                          if (filtro.length === 0 && filtro2) {
                            toastShow(
                              toast,
                              "warn",
                              "Seleccione otro Tipo Producto",
                              "El Tipo Producto seleccionado no cuenta con categorías disponibles",
                            );
                          }
                          return filtro;
                        }}
                      />
                    </span>
                  </div>
                  {/* Tipo Producto */}
                  <div className="field col-3 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        enable={!!values.SubCategoria && camposHabilitados}
                        name={"TipoProducto"}
                        value={values.TipoProducto}
                        items={tipoProducto}
                        field={"NombreTipoProducto"}
                        label={"Tipo"}
                        handleInputChange={handleInputChange}
                        className={error.IdTipoProducto ? "p-invalid" : ""}
                        filterValue={values?.SubCategoria}
                        itemsFilter={(e) => {
                          let filtro = tipoProducto.filter(
                            (s) =>
                              s.IdSubCategoria ===
                              values?.SubCategoria?.IdSubCategoria,
                          );

                          return filtro;
                        }}
                      />
                    </span>
                  </div>
                </div>

                {/* Moneda */}
                <div className="modal__input-contenedor">
                  <div className="field col-3 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"Moneda"}
                        value={values.Moneda}
                        items={moneda}
                        field={"Currency"}
                        label={"Moneda"}
                        handleInputChange={handleInputChange}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        className={error.IdCurrency ? "p-invalid" : ""}
                        filterValue={values?.Moneda}
                      />
                    </span>
                  </div>

                  {!esMateriaPrima && (
                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          name="Minimo"
                          value={values.Minimo}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          autoComplete="off"
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.Minimo ? "p-invalid" : ""}
                          // readOnly={!camposHabilitados}
                          disabled={!camposHabilitados}
                        />
                        <label htmlFor="Minimo">Cantidad Mínina</label>
                      </span>
                    </div>
                  )}

                  {!esMateriaPrima && (
                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          name="CantidadMaxima"
                          value={values.CantidadMaxima}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          autoComplete="off"
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.CantidadMaxima ? "p-invalid" : ""}
                          disabled={!camposHabilitados}
                        />
                        <label htmlFor="CantidadMaxima">Cantidad Máxima</label>
                      </span>
                    </div>
                  )}

                  <div className="field col-3 me-2 mt-2">
                    <span className="p-float-label">
                      <AutoCompleteDropdown
                        name={"UnidadMedida"}
                        value={values.UnidadMedida}
                        items={unidadMedida}
                        field={"UnitName"}
                        label={"Unidad Medida"}
                        handleInputChange={handleInputChange}
                        abelStyle={{
                          color: "gray",
                          textShadow: "0px 0px 1px white",
                        }}
                        // readOnly={camposHabilitados}
                        // enable={camposHabilitados}
                        className={error.IdUnit ? "p-invalid" : ""}
                      />
                    </span>
                  </div>
                </div>

                {/* Bodegas */}
                {!esMateriaPrima && (
                  <div className="modal__input-contenedor">
                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Bodega"}
                          value={values.Bodega}
                          items={bodega}
                          field={"NombreBodega"}
                          label={"Bodega"}
                          enable={camposHabilitados}
                          handleInputChange={(e) => {
                            handleInputChange(e);
                            setValues((prevValues) => ({
                              ...prevValues,
                              Estante: null,
                              Posicion: null,
                              Bandeja: null,
                            }));
                          }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.IdBodega ? "p-invalid" : ""}
                        />
                      </span>
                    </div>

                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Estante"}
                          enable={!!values.Bodega}
                          value={values.Estante}
                          items={estante}
                          field={"NombreEstante"}
                          label={"Estante"}
                          handleInputChange={(e) => {
                            handleInputChange(e);
                            setValues((prevValues) => ({
                              ...prevValues,
                              Posicion: null,
                            }));
                          }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.IdEstante ? "p-invalid" : ""}
                          filterValue={values?.Bodega}
                          itemsFilter={(e) => {
                            let filtro = estante.filter(
                              (s) => s.IdBodega === values?.Bodega?.IdBodega,
                            );
                            let filtro2 = values?.Bodega?.IdBodega;
                            if (filtro.length === 0 && filtro2) {
                              toastShow(
                                toast,
                                "warn",
                                "Seleccione otra Bodega",
                                " La Bodega seleccionada no cuenta con Estantes disponibles",
                              );
                            }
                            return filtro;
                          }}
                        />
                      </span>
                    </div>

                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Posicion"}
                          enable={!!values.Estante}
                          value={values.Posicion}
                          items={posicion}
                          field={"NombrePosicion"}
                          label={"Fila"}
                          handleInputChange={(e) => {
                            handleInputChange(e);
                            setValues((prevValues) => ({
                              ...prevValues,
                              Bandeja: null,
                            }));
                          }}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.IdPosicion ? "p-invalid" : ""}
                          filterValue={values?.Estante}
                          itemsFilter={(e) => {
                            let filtro = posicion.filter(
                              (s) => s.IdEstante === values?.Estante?.IdEstante,
                            );
                            let filtro2 = values?.Estante?.IdEstante;
                            if (filtro.length === 0 && filtro2) {
                              toastShow(
                                toast,
                                "warn",
                                "Seleccione otro Estante",
                                " El Estante seleccionado no cuenta con posiciones disponibles",
                              );
                            }
                            return filtro;
                          }}
                        />
                      </span>
                    </div>

                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"Bandeja"}
                          enable={!!values.Posicion}
                          value={values.Bandeja}
                          items={bandeja}
                          field={"NombreBandejaLado"}
                          label={"Bandeja"}
                          handleInputChange={handleInputChange}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          className={error.IdBandeja ? "p-invalid" : ""}
                          filterValue={values?.Posicion}
                          itemsFilter={(e) => {
                            let filtro = bandeja.filter(
                              (s) =>
                                s.IdPosicion === values?.Posicion?.IdPosicion,
                            );
                            let filtro2 = values?.Posicion?.IdPosicion;
                            if (filtro.length === 0 && filtro2) {
                              toastShow(
                                toast,
                                "warn",
                                "Seleccione otra fila",
                                "La fila seleccionada no cuenta con Bandejas disponibles",
                              );
                            }
                            return filtro;
                          }}
                        />
                      </span>
                    </div>
                  </div>
                )}

                {/* Unidad Medida Vida Util */}
                {!esMateriaPrima && (
                  <div className="modal__input-contenedor">
                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <AutoCompleteDropdown
                          name={"UnidadMedidaVU"}
                          value={values.UnidadMedidaVU}
                          items={unidadMedidaVU}
                          field={"UnitName"}
                          label={"Unidad Medida Vida Util"}
                          handleInputChange={handleInputChange}
                          abelStyle={{
                            color: "gray",
                            textShadow: "0px 0px 1px white",
                          }}
                          // readOnly={camposHabilitados}
                          // enable={camposHabilitados}
                          className={error.IdUnit ? "p-invalid" : ""}
                        />
                      </span>
                    </div>

                    <div className="field col-3 me-2 mt-2">
                      <span className="p-float-label">
                        <InputNumber
                          name="VidaUtil"
                          value={values.VidaUtil}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          className={error.VidaUtil ? "p-invalid" : ""}
                        />
                        <label htmlFor="VidaUtil">Vida Util</label>
                      </span>
                    </div>
                  </div>
                )}

                <div className="modal__input-contenedor hidden">
                  <div className="field col-4 me-2 mt-2">
                    <span className="p-float-label">
                      <InputText
                        name="FechaUpdate"
                        value={values.FechaUpdate}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        readOnly
                        label={"Fecha"}
                      />
                      <label htmlFor="FechaUpdate">Fecha de Creación</label>
                    </span>
                  </div>
                </div>

                {/* Permisos */}
                {!esMateriaPrima && (
                  <div className="p-4">
                    <Card
                      className="mt-2"
                      titulo={<div>Permisos Requisas Compras</div>}
                      contenido={
                        <div className="mb-4 mt-3">
                          <div className="d-flex mx-3">
                            <div className="field col-4 me-2">
                              <span className="p-float-label">
                                <Checkbox
                                  tooltip={permisosG[2]?.Descripcion}
                                  checked={values.AutorizaGerente}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      AutorizaGerente: e.target.checked,
                                    })
                                  }
                                />
                                <label htmlFor="AutorizaGerente">
                                  &nbsp;&nbsp;&nbsp;Autorización Gerente
                                </label>
                              </span>
                            </div>

                            <div className="field col-4 me-2 ">
                              <span className="p-float-label">
                                <Checkbox
                                  tooltip={permisosG[3]?.Descripcion}
                                  checked={values.AutorizaBodega}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      AutorizaBodega: e.checked,
                                    })
                                  }
                                />
                                <label htmlFor="AutorizaBodega" className="ml-2">
                                  &nbsp;&nbsp;&nbsp;Autorización Bodega
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                      }
                    />

                    <Card
                      className="mt-4"
                      titulo={<div>Permisos Requisas Materiales</div>}
                      contenido={
                        <div className="mb-4 mt-3">
                          <div className="d-flex mx-3">
                            <div className="field col-4 me-2">
                              <span className="p-float-label">
                                <Checkbox
                                  readOnly
                                  tooltip={permisosG[5]?.Descripcion}
                                  checked={values.PermisoSalidaBodegaSolicita}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      PermisoSalidaBodegaSolicita:
                                        e.target.checked,
                                    })
                                  }
                                />
                                <label htmlFor="PermisoSalidaBodegaSolicita">
                                  &nbsp;&nbsp;&nbsp;Autorización Gerente
                                </label>
                              </span>
                            </div>

                            <div className="field col-4 me-2">
                              <span className="p-float-label">
                                <Checkbox
                                  tooltip={permisosG[6]?.Descripcion}
                                  checked={values.PermisoSalidaBodegaRRHH}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      PermisoSalidaBodegaRRHH: e.target.checked,
                                    })
                                  }
                                />
                                <label htmlFor="PermisoSalidaBodegaRRHH">
                                  &nbsp;&nbsp;&nbsp;Autorización RRHH
                                </label>
                              </span>
                            </div>

                            <div className="field col-4 me-2">
                              <span className="p-float-label">
                                <Checkbox
                                  tooltip={permisosG[7]?.Descripcion}
                                  checked={values.PermisoSalidaBodegaMASS}
                                  onChange={(e) =>
                                    setValues({
                                      ...values,
                                      PermisoSalidaBodegaMASS: e.target.checked,
                                    })
                                  }
                                />
                                <label htmlFor="PermisoSalidaBodegaMASS">
                                  &nbsp;&nbsp;&nbsp;Autorización MASS
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                      }
                    />
                  </div>
                )}

                {/* Fecha Modificacion */}
                <div className="modal__input-contenedor">
                  <div className="field col-6 me-2" hidden>
                    <span className="p-float-label">
                      <InputText
                        name="FechaModificacion"
                        value={values.FechaModificacion}
                        onChange={handleInputChange}
                        style={{ width: "100%" }}
                        autoComplete="off"
                        readOnly
                      />
                      <label htmlFor="Fecha Modificacion">
                        Fecha Modificacion
                      </label>
                    </span>
                  </div>
                </div>
              </div>
            </TabPanel>

            <TabPanel
              header="Agregar Imágen"
              visible={hiddenAgregarImg && values?.IdProduct > 0}
            >
              <div style={{ width: "auto", height: "50vh" }}>
                <FileUpload
                  ref={fileUpload}
                  name="demo"
                  url="./upload"
                  multiple
                  accept="image/*"
                  customUpload
                  uploadHandler={subirArchivo}
                  maxFileSize={40000000}
                />
                <div className="mt-3">
                  <div>
                    {listadoArchivos?.map((a, i) => (
                      <div
                        className="d-flex gap p-2 border mt-2"
                        style={{ alignItems: "center" }}
                        key={i}
                      >
                        <div className="col-10">{a}</div>
                        <Button
                          icon="pi pi-download"
                          onClick={() => getArchivo(a)}
                        />
                        <Button
                          icon="pi pi-trash"
                          severity="danger"
                          onClick={() => eliminarImagenn(a)}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  style={{ top: 350, right: 22 }}
                  className="d-flex justify-content-end"
                >
                  <Button
                    className={"mt-3"}
                    label="Ver Imagenes"
                    disabled={!botonImg}
                    onClick={() => verImagenes()}
                  />
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </Dialog>

      {/* Dialogo para mostrar imagenes */}
      <Dialog
        header={values ? values?.NombreProducto : ""}
        visible={showModalImagenes}
        onHide={cerrarModal}
        className="w-50"
      >
        <div>
          {imagenes.CodigoProducto && (
            <Carousel
              value={imagenes.img}
              circular
              showIndicators={true}
              itemTemplate={(item) => {
                return (
                  <div
                    className="d-flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                      height: "600px",
                    }}
                  >
                    <img
                      src={"data:image/png;base64," + item}
                      alt="imagen"
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                );
              }}
            />
          )}
        </div>
      </Dialog>

      {/* Dialogo para imprimir etiquetas */}
      <Dialog
        header="Imprimir Etiqueta"
        visible={showDialogCodigo}
        style={{ width: "30vw" }}
        onHide={() => setShowDialogCodigo(false)}
        footer={footerContent}
      >
        <p className="m-0">Elija la etiqueta que desea Imprimir</p>
      </Dialog>
    </div>
  );
};

export default CrudProductoModal;